import { PropertyConfig } from '../types/property-config';
import { PropertyConfigModel } from '@/models/property-config';
import { upperFirst } from 'lodash';

export function transformPropertyConfig(propertyConfig: PropertyConfig): PropertyConfigModel {
    return {
        ...propertyConfig,
        config: {
            ...propertyConfig.config,
            typeName: upperFirst(propertyConfig.config?.referenceType?.replaceAll('-', ' ')),
        }
    };
}

export function transformPropertyConfigs(propertyConfigs: PropertyConfig[]): PropertyConfigModel[] {
    return propertyConfigs.map(transformPropertyConfig);
}
